export default "__VITE_ASSET__B8LBfQ6O__"